<template>
  <div class="main-container customer-table-height">
    <transition :css="false">
      <el-dialog title="Edit GroupItems" :visible.sync="editModal" width="40%">
        <form>
          <arnergy-dynamic
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
            @subgroup="getSubgroupss"
          />

          <div v-show="form.groupID" class="form-check ml-3">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              v-model="form.status"
              id="defaultCheck1"
            />
            <label class="form-check-label" for="defaultCheck1">
              Do you want to add device to Subgroup?
            </label>
          </div>
          <br />
          <div v-show="form.status">
            <arnergy-select
              v-model="form.subgroup"
              label="Subgroup"
              :items="subgroups"
            />
          </div>

          <div>
            <multiselect
              v-model="value"
              :options="users"
              :multiple="false"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select Users You want"
              label="name"
              track-by="id"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </div>

          <!-- <div class="form-group">
          <label for="exampleFormControlTextarea1">Device ID</label>
          <input type="text"
          style="height: 5rem"
            v-model="form.device"
            class="form-control"
            id="exampleFormControlTextarea1"
          />
        </div> -->

          <div class="pt-4 text-right">
            <div v-if="loader" className="text-center">
              <div class="submit-gif">
                <div
                  class="spinner-border"
                  style="width: 3rem; height: 3rem;"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else>
              <button class="btn btn-primary" @click="updateGroup">
                Edit GroupItems
              </button>
            </div>
          </div>
        </form>
      </el-dialog>
    </transition>

    <div style="width: 100%;">
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        a
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="getGroupUsers"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <span
            v-if="
              props.column.field == 'actions' && usertype != 'customer admin'
            "
          >
            <b-button size="md" variant="success" @click="editmodal(props.row)">
              Edit Customers &nbsp;
              <span class="fa fa-wrench"></span>
            </b-button>
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>
        <template slot="table-row" slot-scope="props">
          <span
            v-if="
              props.column.field == 'actions' && usertype != 'customer admin'
            "
          >
            <!-- <b-button
              size="md"
              variant="danger"
              class="d-none"
              @click="deleteCustomer(props.row.id)"
            >
              Delete&nbsp;
              <span class="fa fa-wrench"></span>
            </b-button> -->
            <b-button
              size="md"
              :disabled="loading"
              variant="success"
              @click="editmodal(props.row)"
            >
              {{ loading ? "Loading..." : "Edit" }}
              <span class="fa fa-wrench"></span>
            </b-button>
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  Dialog,
  RadioGroup,
  RadioButton,
  Row
  // ...
} from "element-ui";
import moment from "moment";
import Multiselect from "vue-multiselect";
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import ArnergyDynamic from "../kitchen/AnergySelectDynamic.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  components: {
    "el-dialog": Dialog,
    Multiselect,
    ArnergyDynamic,
    ArnergySelect
  },
  data() {
    return {
      searchTerm: "",
      users: [],
      value: {},
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },

      editModal: false,
      loader: false,
      form: {
        groupID: "",
        subgroup: "",
        usersID: "",
        status: false
      },
      updateID: "",
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      value: [],
      items: items,
      fields: [
        {
          field: "groupname",
          label: "Group Name",
          sortable: "true"
        },
        {
          field: "subgroupname",
          label: "Subgroup Name",
          sortable: "true"
        },
        {
          field: "email",
          label: "Email",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions",
          hidden: false
        }

        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      ],
      cxTeamFields: [
        {
          field: "id",
          label: "Group Name",
          sortable: "true"
        },
        {
          field: "fu",
          label: "Subgroup Name",
          sortable: "true"
        },
        {
          field: "Device",
          label: "User Type",
          sortable: "true"
        },
        {
          field: "Status",
          label: "E-mail",
          sortable: "true"
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true"
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true"
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions",
          hidden: true
        }
      ],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getGroupUsers",
      "getGroups",
      "getSubgroups",
      "getGroupItems",
      "getDummy",
      "getDevices"
    ]),
    isACxTeam: {
      get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    deleteCustomer(id) {
      const HTTP = this.$httpUtils.instance;
      let c = confirm("Are you sure?");
      if (c) {
        const url = `/groupUsers/${id}`;
        HTTP.delete(url).then(response => {
          this.showSuccessAlert("Deleted.");
          this.fetchGroupItems();
        });
      }
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchGroupItems() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/groupUsers/getGroupUsers`;
      HTTP.post(url)
        .then(response => {
          const list = response.data;
          // console.log({ list });
          this.$store.commit("saveGroupUsers", list);
          // console.log(this.getUserById(1))
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    async editmodal(row) {
      this.loading = true;
      let { id } = row;
      this.updateID = id; //groupUsers/getGroupUsers
      const HTTP = this.$httpUtils.instance;
      const filter = JSON.stringify({
        where: { id: `${id}` },
        include: ["user"]
      });
      const url = `/groupUsers?filter=${filter}`;
      HTTP.get(url)
        .then(async res => {
          let { data } = res;
          if (data.length > 0) {
            let { user } = data[0];
            this.form.subgroup = data[0].subgroupid;
            this.form.status = data[0].subgroupid ? true : false;
            this.form.groupID = data[0].groupid; //groups.find(v=>v.id==data[0].groupid);
            this.value = this.users.find(v => v.id == data[0].userid);
            await this.getSubgroupss(this.form.groupID);
            this.editModal = true;
            this.loading = false;
          }
        })
        .catch(error => {
          console.log("error", error);
          this.loading = false;
        });
    },
    showSuccessAlert(msg) {
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: msg,
        icon: "success",
        width: "550px"
      });
    },
    async getSubgroupss(id) {
      const HTTP = this.$httpUtils.instance;
      let formData = new FormData();
      formData.append("groupid", id);
      let res = await HTTP.post(
        "/customerSubGroups/getCustomerSubGroupByGroupId",
        formData
      )
        .then(res => {
          if (res.data) {
            this.subgroups = res.data
              .map(item => {
                return {
                  id: item.id,
                  name: item.subgroupname
                };
              })
              .sort((a, b) => {
                return a.name > b.name ? 1 : -1;
              });
          }
          console.log(this.subgroupsData);
        })
        .catch(e => {
          //
        });
      // parse for "arnergy-select" us
    },

    updateGroup(e) {
      e.preventDefault();
      const HTTP = this.$httpUtils.instance;
      let { groupID, subgroup } = this.form;
      let { id: userid } = this.value;
      const data = {
        groupid: groupID,
        subgroupid: subgroup,
        userid,
        id: this.updateID
      };
      this.loader = true;
      console.log(data);
      HTTP.put("/groupUsers", data)
        .then(res => {
          if (res.data) {
            this.editModal = false;
            this.showAlert();
            this.loader = false;
            this.fetchGroupItems();
            this.form.subgroup = "";
            this.form.groupname = "";
            this.form.deviceid = "";
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "GroupItem Updated Successfully",
        icon: "success",
        width: "550px"
      });
    },
    async fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      let res = await HTTP.get("/users");

      // parse for "arnergy-select" use
      this.users = res.data
        .map(item => {
          return {
            id: item.id,
            name: item.email
          };
        })
        .sort((a, b) => {
          return a.nme > b.name ? 1 : -1;
        });
    },

    fetchDevices() {
      const HTTP = this.$httpUtils.instance;
      HTTP.post("/groupUsers/getGroupUsers").then(res => {
        if (res.data) {
          this.devices = res.data
            .map(item => {
              return {
                id: item.CID && item.CID
              };
            })
            .sort((a, b) => {
              return a.id > b.id ? 1 : -1;
            });
        }
      });

      // parse for "arnergy-select" use
    }
  },
  mounted() {
    // console.log(this.getGroups);
    this.devices = this.fetchDevices();
    this.fetchGroupItems();
    this.fetchUsers();

    this.groups = this.getGroups
      .map(item => {
        return {
          id: item.id,
          name: item.groupname
        };
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.customer-table-height {
  height: calc(100vh - 450px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/CustomersInfo.vue